
import { computed, Ref } from 'vue';

export default {
  name: 'CircularProgress',
  props: {
    progress: Number,
  },
  setup(props: { progress: number }): { progressValue: Ref<number> } {
    const progressValue: Ref<number> = computed(() => props.progress);
    return {
      progressValue,
    };
  },
};
